function toggleNavigation(e) {
	e.preventDefault();
	$('#mobile-nav').slicknav('toggle');
}

function init() {

	// Add header supplements
	//*******************************************
	const patty = document.createElement('span');
	const hamburger = document.createElement('a');
	hamburger.classList.add('hamburger', 'icon');
	hamburger.innerText = 'Toggle menu';
	hamburger.href = '#';
	hamburger.addEventListener('click', toggleNavigation);
	hamburger.appendChild(patty);

	const lens = document.createElement('a');
	lens.classList.add('lens', 'icon');
	lens.innerText = 'Search';
	lens.href = '/suche';

	const header = document.createElement('div');
	header.classList.add('responsive-only', 'responsive-navigation');
	header.appendChild(lens);
	header.appendChild(hamburger);
	document.querySelector('.banner .rwd-object-halign').appendChild(header);

	// Initialize mobile navigation
	//*******************************************
	$('#mobile-nav').slicknav({
		duplicate: false,
		label: '',
		appendTo: '.banner',
		allowParentLinks: true,
		nestedParentLinks: false,
		beforeOpen: function() {
			$("body").addClass("noscroll")
		},
		afterClose: function() {
			$("body").removeClass("noscroll")
		}
	});

	/** responsive table **/
	$('.searcheza .database table').wrap('<div class="responsive-table" />');

	/** solr stuff **/
	$('#tx-solr-faceting').prepend(
		$('<a />')
			.attr('href', '#')
			.addClass('toggle-filter')
			.prepend(
				'<span class="de">Filter einblenden</span>'+
				'<span class="en">Show filter</span>'
			)
	);

	$(document).on('click', '.toggle-filter', function(e){
		e.preventDefault();
		$('#tx-solr-facets-available').toggleClass('toggle');
	})
}

if (document.readyState === 'interactive') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', init);
}
